/**
 * @generated SignedSource<<2047e07ec67a8e1074c3a9a5171c8dd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilters_viewer">;
  readonly " $fragmentType": "SbRespRefineMenuDrawer_viewer";
};
export type SbRespRefineMenuDrawer_viewer$key = {
  readonly " $data"?: SbRespRefineMenuDrawer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5bf5ef49032bf59bafa4069b0dbe702d";

export default node;
